import css from 'styled-jsx/css';

const styles = css`.school-name{display:inline-block}.school-name .logo{max-height:150px;display:inline;vertical-align:middle}.school-name.small .logo{max-height:50px}`;

export default styles;